import { RECEIPT_PAYMENT_MODE_ID } from "@elixir/types";
import React from "react";
import { PAY_MODES } from "../../constants/receipt";
import FilterBoxWithDropdown from "../../molecules/filter-dropdowns/filter-dropdown";
import useBillingStore from "../../stores/billing-store/billing-store";
import { TPaymentModeIds } from "../../types/receipt";

type TPaymodesUsedObject = Record<RECEIPT_PAYMENT_MODE_ID, number>;

const PaymodeFilterDropdown = () => {
  const [showDropdown, setShowDropdown] = React.useState(false);

  const { receiptEntities, paymodeFilters, setPaymodeFilters } =
    useBillingStore();

  const listOfPaymodesWithPrice = React.useMemo(() => {
    const objectListOfPaymodesWithPrice = receiptEntities.reduce(
      (objectSoFar, receipt) => {
        const { paymentItems } = receipt;
        paymentItems.forEach((pay) => {
          objectSoFar[pay.paymode] =
            (objectSoFar[pay.paymode] || 0) + pay.amount;
        });
        return objectSoFar;
      },
      {} as TPaymodesUsedObject
    );

    return Object.keys(objectListOfPaymodesWithPrice).map((paymode) => ({
      id: paymode,
      label: PAY_MODES.find((mode) => mode.id === paymode)?.name || paymode,
      labelSubtext:
        `₹${objectListOfPaymodesWithPrice[
          paymode as TPaymentModeIds
        ]?.toString()}` || "",
    }));
  }, [receiptEntities]);

  const handleSelectedOptions = (options: Array<string | number>) => {
    setPaymodeFilters(options as Array<string>);
  };

  const filterHeading = React.useMemo(() => {
    if (paymodeFilters.length === 0 || showDropdown) {
      return "Paymode";
    }

    return paymodeFilters
      .map(
        (filterMode) => PAY_MODES.find((mode) => mode.id === filterMode)?.name
      )
      .join(", ");
  }, [paymodeFilters, showDropdown]);

  return (
    <FilterBoxWithDropdown
      title={filterHeading}
      options={listOfPaymodesWithPrice}
      selectedOptions={paymodeFilters}
      setSelectedOptions={handleSelectedOptions}
      showDropdown={showDropdown}
      toggleDropdown={() => {
        setShowDropdown(!showDropdown);
      }}
      closeDropdown={() => {
        setShowDropdown(false);
      }}
    />
  );
};

export default PaymodeFilterDropdown;
